/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Placeholder } from 'sarsaparilla';
import './HeroGalleryPlaceholder.scss';

export default function HeroGalleryPlaceholder() {
    return (
        <div className="hero-gallery-placeholder" aria-hidden="true">
            <Placeholder
                className="hero-gallery-placeholder-surface"
                height="100%"
                width="100%"
            />
            <div className="hero-gallery-placeholder-controls">
                <div className="hero-gallery-placeholder-top-controls">
                    <div className="hero-gallery-placeholder-top-actions">
                        <Placeholder
                            className="hero-gallery-placeholder-action"
                            height="40px"
                            width="40px"
                        />
                        <Placeholder
                            className="hero-gallery-placeholder-action"
                            height="40px"
                            width="40px"
                        />
                    </div>
                </div>
                <div className="hero-gallery-placeholder-bottom-controls">
                    <Placeholder
                        className="hero-gallery-placeholder-counter"
                        height="24px"
                        width="56px"
                    />
                </div>
            </div>
        </div>
    );
}
